import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import s from './Popover.module.scss';
import Icon from '../Icon';
import { AnimateInOut } from '../Animate/Animate';
import classNames from 'classnames';

const Popover = ({
    children,
    content,
    minWidth = '',
    popoverWidth = '',
    disableLayoutAnimation = false,
    popoverRef,
    isPopoverOpen,
    onClick,
    modifier,
    modifiers = [],
    overrideButton,
    openPopoverOverButton = false,
    disabled = false,
}) => {
    const modifierList = [];

    if (modifier) {
        modifierList.push(...(Array.isArray(modifier) ? modifier : [modifier]));
    }

    if (modifiers.length > 0) {
        modifierList.push(...modifiers);
    }
    const classes = classNames(
        s.Root,
        modifierList.map((name) => s[`Root--${name}`]),
        {
            [s.Disabled]: disabled,
            [s.OpenOverButton]: openPopoverOverButton,
        }
    );

    return (
        <div className={classes} ref={popoverRef}>
            {!!overrideButton &&
                React.cloneElement(overrideButton, { onClick })}
            {!overrideButton && (
                <button
                    className={s.ToggleButton}
                    onClick={onClick}
                    disabled={disabled}>
                    {children}
                </button>
            )}
            <AnimateInOut
                isVisible={isPopoverOpen}
                className={s.Animate}
                disableLayoutAnimation={disableLayoutAnimation}>
                {isPopoverOpen && (
                    <div
                        className={s.Popover}
                        style={{
                            minWidth: minWidth,
                            width: popoverWidth || undefined,
                        }}>
                        <div className={s.Content}>{content}</div>
                    </div>
                )}
            </AnimateInOut>
        </div>
    );
};

Popover.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
    content: PropTypes.node,
    modifier: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
    ]),
    modifiers: PropTypes.arrayOf(PropTypes.string),
    button: PropTypes.shape({
        text: PropTypes.string,
        icon: PropTypes.string,
    }),
};

export default Popover;
